import gsap from 'gsap';

export default () => {
  let heroSlide = document.querySelector('.hero-slider__item');

  if(heroSlide){

    let heroSlide = document.querySelectorAll('.hero-slider__item');

    heroSlide.forEach((heroSlide) => {

      let heroTextLine = heroSlide.querySelectorAll('.hero-slider__text-line');
      let heroImage = heroSlide.querySelector('.hero-slider__image');
      let heroLines = heroSlide.querySelectorAll('.hero-slider__line');

      let tl = new gsap.timeline();

      tl.set(heroImage, {opacity: 0});

      heroLines.forEach(heroLine => {
        tl.set(heroLine, {scaleX: 0});
      });

      heroTextLine.forEach(textItem => {
        var str = textItem.innerText;
        textItem.innerHTML = '';

        var words = str.split(" ");
        for (var i = 0; i < words.length; i++) {
          textItem.innerHTML += '<span class="text-word">'+ words[i] + '</span> ';
        }

        let textWords = textItem.querySelectorAll('.text-word');

        textWords.forEach(textWord => {
          tl.set(textWord, { opacity: 0, x: '-80px' });
        });

      });

    });

    let coef = 0;
    startHeroSlider(heroSlide[coef]);

    setInterval(() => {
      endHeroSlider(heroSlide[coef]);

      coef++;
      if(coef == heroSlide.length){
        coef = 0;
      }

      setTimeout(() => {
        startHeroSlider(heroSlide[coef]);
      }, 300);
 
    }, 5000); 


    
    function setHeroSlider(heroSlide) {
      let heroImage = heroSlide.querySelector('.hero-slider__image');
      let heroContent = heroSlide.querySelector('.hero-slider__content');
      let heroLines = heroSlide.querySelectorAll('.hero-slider__line');
      let heroText = heroSlide.querySelector('.hero-slider__text');

      let tr = new gsap.timeline();

      tr.set(heroContent, {x: 0})
        .set(heroText, {opacity: 1})
        .set(heroImage, {scale: 1})
        .set(heroLines, {transformOrigin:"left"});

      let textWords = heroSlide.querySelectorAll('.text-word');
      tr.set(textWords, { opacity: 0, x: '-80px'});

    }


    function startHeroSlider(heroSlide) {

      setHeroSlider(heroSlide);

      let heroTextLine = heroSlide.querySelectorAll('.hero-slider__text-line');
      let heroImage = heroSlide.querySelector('.hero-slider__image');
      let heroContent = heroSlide.querySelector('.hero-slider__content');
      let heroLines = heroSlide.querySelectorAll('.hero-slider__line');

      let tl = new gsap.timeline();
      let tm = new gsap.timeline();

      tl.to(heroImage, {opacity: .8, duration: .4});
      tm.to(heroImage, {scale: 1.05, duration: 6});


      heroLines.forEach(heroLine => {
        tl.to(heroLine, {scaleX: 1, duration: .8, delay: -.4});
      });

      heroTextLine.forEach((textItem, k) => {
        let textWords = textItem.querySelectorAll('.text-word');

        textWords.forEach((textWord, i) => {
          tl.to(textWord, { opacity: 1, duration: .8, 
                          ease: "power1.in", delay: -.8 + 0.1 * i });

          tl.to(textWord, { x: 0, duration: .5, 
                            ease: "power1.out", delay: -.8 + 0.001 * i });
          
        });
      });

      tl.to(heroContent, {x: '50px', duration: 5, delay: -1.5});

    }

    function endHeroSlider(heroSlide) {
      let heroImage = heroSlide.querySelector('.hero-slider__image');
      let heroText = heroSlide.querySelector('.hero-slider__text');
      let heroLines = heroSlide.querySelectorAll('.hero-slider__line');

      let tl = new gsap.timeline();

      heroLines.forEach((heroLine, j) => {
        tl.to(heroLine, {scaleX: 0, transformOrigin:"right", duration: .2, delay: -.2 * j});
      });

      tl.to(heroText, {opacity: 0, duration: .7, delay: -.3});
      tl.to(heroImage, {opacity: 0, duration: .3, delay: -.3});

    }

  }
  
}